import type * as React from "react";
import { Suspense } from "react";
import { BookingStepThree } from "@/components/booking";
import { BookingStepOneSkeleton } from "@/components/booking/BookingStepOneSkeleton";

const BookingExtrasPage: React.FC = () => {
  return (
    <Suspense fallback={<BookingStepOneSkeleton />}>
      <BookingStepThree />
    </Suspense>
  );
};

export default BookingExtrasPage;
